/* Icon configurations */
const sizeIcon: {
    Button: number,
    ButtonSmall: number,
    Caption: number,
    H3: number,
    Text: number,
    TextSmall: number
} = {
    Button: 16,
    ButtonSmall: 12,
    Caption: 16,
    H3: 20,
    Text: 16,
    TextSmall: 12
};

/*
 * Export functions.
 */
export {
    sizeIcon
}
